import React from 'react';
import Settings from '../../../Settings/Settings'
import Style from './Styles/OrderItemsElementStyle'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Button from '@mui/material/Button';

export default function OrdersInvoiceAddressComponent(props) {
    const classes = Style();
    const [status, setStatus] = React.useState(props.ordersOrdersStatusesID)
    const handleChangeStatus = (event) => {
      setStatus(event.target.value);
    };
    const componentConstants = {
        ...props.componentConstants
      }
    
      const componentMethods = {
          ...props.componentMethods,
      }

    const updateOrdersStatusesAction = () => {
        let url = Settings.API_URL + Settings.API_ENDPOINT_ORDER + props.ordersID
        let method = "PUT"
        let accountToken = ''
        if(componentMethods.getLocalStorage('user') && componentMethods.getLocalStorage('user').tokensHash) {
            accountToken = '?accountToken=' + componentMethods.getLocalStorage('user').tokensHash
        }
        componentMethods.ajax(url += accountToken, 
            {
              ordersOrdersStatusesID: status
            }, 
            method, 'ordersStatuses', 
            (data) => {
              componentMethods.addError(componentConstants.language.LANG_ORDER_UPDATED)
              componentMethods.getOrdersAction()
            })
        
    }
    
    if(!componentMethods.getManagerState().ordersStatuses)
      return null

  return (<React.Fragment>
        <FormControl style={classes.formControl} fullWidth={true}>
          <InputLabel>{componentConstants.language.LANG_ORDERS_STATUS}</InputLabel>
          <Select
          value={status}
          onChange={handleChangeStatus}
          >
          {componentMethods.getManagerState().ordersStatuses.map((el, index) => {
          return <MenuItem key={index} value={el.ordersStatusesID}>{componentConstants.language[el.ordersStatusesName]}</MenuItem>
          })}
          </Select>
      </FormControl>
      {props.ordersOrdersStatusesID !== status ?
          <Button style={classes.button} color="primary" onClick={updateOrdersStatusesAction} fullWidth component="div" variant="contained">
            {componentConstants.language.LANG_UPDATE_ORDERS_STATUS}
        </Button>
        :
        null
      }
      
      </React.Fragment>
  );
}